module.exports = __webpack_public_path__ + "static/img/bofang2.898325c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/bofang2.png
// module id = v/rG
// module chunks = 24